import BaseServiceV2, { IHttpResponse, IUri } from '../BaseServiceV2';
import {
  fetchAuthProviders,
  getAuthorizedProvider,
} from '@omni/kit/services/AuthService/utilities';

import AccountsService from '../AccountsService';
import AuthService from '../AuthService';
import { BridgeAction } from '@omni/kit/Types';

export interface ICustomProfileHeader {
  title?: string; // aka user full name / nickname
  subtitle?: string; // aka user initials
  actions?: BridgeAction[]; // aka custom 'edit account' screen
}

interface IGetCustomProfileHeader extends IUri {
  appKey: string;
  url: string;
}

interface ICustomProfileHeaderFeedResponse extends IHttpResponse {
  body?: ICustomProfileHeader;
}

export default async function ({
  appKey,
  url,
}: IGetCustomProfileHeader): Promise<ICustomProfileHeaderFeedResponse> {
  const app = await AccountsService.getApp(appKey);
  const orgKey = app.org_key;
  const providers = await fetchAuthProviders({ appKey, orgKey });
  const authorizedProvider = getAuthorizedProvider({ providers, url });

  if (!authorizedProvider) {
    return Promise.reject('Custom Profile Header: No authorized provider');
  }

  const tokenResponse = await AuthService.requestAccessToken(
    authorizedProvider.token_url,
    'app'
  );

  if (!tokenResponse.ok) {
    return Promise.reject('Custom Profile Header: Failed to get token');
  }

  const json = await tokenResponse.json();
  const token = json.access_token;

  return BaseServiceV2.Get({
    domainPreValidated: true,
    token,
    skipTimestamp: true,
    skipCaching: true,
    url,
  });
}
